import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('CRASH in', this.props.name || 'Component', error);
    console.error('Component stack:', info.componentStack);
    this.setState({ info });
  }

  copyError = () => {
    const { error, info } = this.state;
    const txt = [
      error?.message || String(error),
      '',
      error?.stack || '',
      '',
      info?.componentStack || '',
    ].join('\n');
    navigator.clipboard.writeText(txt).then(() => alert('Copied'));
  };

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    const box = {
      background: '#fef2f2',
      border: '1px solid #fecaca',
      color: '#991b1b',
      padding: 12,
      borderRadius: 8,
      overflow: 'auto',
      maxHeight: 300,
      fontFamily: 'ui-monospace, monospace',
      fontSize: 12,
      lineHeight: 1.5,
      marginBottom: 10,
      whiteSpace: 'pre-wrap',
    };

    const box2 = {
      ...box,
      background: '#faf7f2',
      border: '1px solid #e8dcc8',
      color: '#3d3325',
      fontSize: 11,
    };

    const btn = {
      padding: '9px 16px',
      borderRadius: 8,
      border: 'none',
      cursor: 'pointer',
      background: 'linear-gradient(135deg,#dcb254,#a87a2b)',
      color: '#fff',
      fontWeight: 700,
      fontFamily: 'system-ui, sans-serif',
    };

    const btnAlt = { ...btn, background: '#f4ede2', color: '#5c4d38' };
    const sum = { cursor: 'pointer', fontWeight: 700, marginBottom: 6, fontFamily: 'system-ui' };

    return (
      <div style={{ padding: 20, maxWidth: 820, margin: '30px auto' }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, color: '#8b2635', marginBottom: 10, fontFamily: 'system-ui' }}>
          Crash in &lt;{this.props.name || 'Unknown'}&gt;
        </h1>

        <pre style={box}>{error.message || String(error)}</pre>

        {error.stack ? (
          <details open>
            <summary style={sum}>Stack trace</summary>
            <pre style={box2}>{error.stack}</pre>
          </details>
        ) : null}

        {info && info.componentStack ? (
          <details open>
            <summary style={sum}>Component tree</summary>
            <pre style={box2}>{info.componentStack}</pre>
          </details>
        ) : null}

        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button onClick={() => window.location.reload()} style={btn}>Reload</button>
          <button onClick={() => { window.location.href = '/feed'; }} style={btnAlt}>Go to Wall</button>
          <button onClick={this.copyError} style={btnAlt}>Copy error</button>
        </div>
      </div>
    );
  }
}